export const USER_ROLES = {
	ADMIN : "admin",
	PARTNER : "partner",
	GUEST : "guest"
};